/*eslint-disable*/
import Api from "../";

class PresentationsThemesApi {
    static list(params, cancelToken = null) {
        return Api.axios.post('/presentations-themes/list', params, {cancelToken}).then(response => response.data);
    }

    static create (params) {
        return Api.axios.post('/presentations-themes/create', params)
            .then(response => response.data);
    }

    static show (id) {
        return Api.axios.get('/presentations-themes/' + id)
            .then(response => response.data);
    }

    static update (params) {
        return Api.axios.put('/presentations-themes/' + params.id, params.theme)
            .then(response => response.data)
    }

    static delete (id) {
        return Api.axios.delete('/presentations-themes/' + id)
            .then(response => response.data)
    }
}

export default PresentationsThemesApi;
